function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "contrast_x5F_t"
}, React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 3.456,
  strokeMiterlimit: 10,
  x1: 33.278,
  y1: 52.002,
  x2: 66.64,
  y2: 52.002
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 3.456,
  strokeMiterlimit: 10,
  x1: 66.64,
  y1: 0,
  x2: 66.64,
  y2: 100
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 3.456,
  strokeMiterlimit: 10,
  x1: 33.278,
  y1: 0,
  x2: 33.278,
  y2: 100
}), React.createElement("path", {
  fill: "#0E426B",
  d: "M96.544,3.456v93.088H3.456V3.456H96.544 M100,0H0v100h100V0L100,0z"
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#009AD7",
  cx: 49.875,
  cy: 19.724,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 49.917,
  cy: 19.724,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 46.368,
  y1: 10.94,
  x2: 46.368,
  y2: 28.631
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 49.875,
  y1: 10.25,
  x2: 49.875,
  y2: 29.198
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 53.385,
  y1: 11.084,
  x2: 53.385,
  y2: 28.526
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  cx: 16.577,
  cy: 56.673,
  r: 9.473
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 16.619,
  cy: 56.673,
  r: 9.473
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 13.067,
  y1: 47.89,
  x2: 13.067,
  y2: 65.578
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 16.577,
  y1: 47.2,
  x2: 16.577,
  y2: 66.146
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 20.085,
  y1: 48.034,
  x2: 20.085,
  y2: 65.473
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  cx: 83.217,
  cy: 29.814,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 83.257,
  cy: 29.814,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 79.708,
  y1: 21.031,
  x2: 79.708,
  y2: 38.72
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 83.217,
  y1: 20.34,
  x2: 83.217,
  y2: 39.289
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 86.725,
  y1: 21.174,
  x2: 86.725,
  y2: 38.614
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  cx: 49.939,
  cy: 84.279,
  r: 9.475
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 49.979,
  cy: 84.279,
  r: 9.475
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 46.43,
  y1: 75.496,
  x2: 46.43,
  y2: 93.186
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 49.939,
  y1: 74.805,
  x2: 49.939,
  y2: 93.754
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 53.446,
  y1: 75.639,
  x2: 53.446,
  y2: 93.078
}));

var SvgContrastTracking = function SvgContrastTracking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "contrast_x5F_t",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContrastTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ContrastTracking.5cbc5e2d.svg";
export { ForwardRef as ReactComponent };